<div class="search-subscription">
  <button
    class="search-subscription__mobile-button mdc-button"
    (click)="open()"
  >
    <span class="mdc-button__ripple"></span>
    <span class="mdc-button__label">
      {{ 'searchSubscription.setup' | i18n }}
    </span>
    <span class="mdc-button__touch"></span>
  </button>

  <div
    class="search-subscription__wizard search-subscription__wizard--mobile"
    *ngIf="isMobileOpen"
  >
    <app-mobile-wizard (requestClose)="close()"></app-mobile-wizard>
  </div>

  <div class="search-subscription__wizard search-subscription__wizard--desktop">
    <app-desktop-wizard></app-desktop-wizard>
  </div>
</div>
